let loadRegistry = { };

export const addLoader = (url, promise) => {
  loadRegistry[url] = promise;
};
export const findLoader = (url) => {
  return Boolean(loadRegistry[url]) && loadRegistry[url];
};
